import React from "react";
import styles from "./SegmentUpdateCompleted.module.scss";
import DoneImage from "../../../Components/assets/Images/congratsdoneimage.svg";

function SegmentUpdationCompleted() {
  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>
              {" "}
              Thank You for Submitting Your Request!
            </p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                Your modification has been successfully completed, and you will
                receive a confirmation email with all the details shortly.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SegmentUpdationCompleted;
